import { render, staticRenderFns } from "./SmallSlimsLoader.vue?vue&type=template&id=cde4b9ce&scoped=true"
import script from "./SmallSlimsLoader.vue?vue&type=script&lang=js"
export * from "./SmallSlimsLoader.vue?vue&type=script&lang=js"
import style0 from "./SmallSlimsLoader.vue?vue&type=style&index=0&id=cde4b9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde4b9ce",
  null
  
)

export default component.exports